angular.module('storefrontApp')
    .controller('storeLocatorController', [
        '$scope',
        '$compile',
        'rsStoreLocatorService',
        function (
            $scope,
            $compile,
            rsStoreLocatorService,
        ) {
            function initialize() {
                $scope.postalCode = '';
                $scope.radius = '50';
                $scope.postalCode = '';
                $scope.foundStoresCount = 0;
                $scope.currentPositionMarker = null;
                $scope.errorMessage = '';

                $scope.map = new google.maps.Map(angular.element('#storeLocatorMap')[0], {
                    zoom: 4,
                    center: {
                        lat: 41.850033,
                        lng: -87.6500523,
                    }, // default center of USA (Chicago)
                    mapTypeControl: false,
                    streetViewControl: false,
                    gestureHandling: 'greedy',
                    mapId: 'e1b43fb02c121d19',
                });

                $scope.autocomplete = new google.maps.places
                    .Autocomplete(angular.element('#storeLocatorAutocomplete')[0]);
                $scope.autocomplete.bindTo('bounds', $scope.map);
                $scope.autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);

                google.maps.event.addListener($scope.autocomplete, 'place_changed', function () {
                    $scope.$apply($scope.searchPlaceChanged());
                });

                getCurrentPosition();

                $scope.size = new google.maps.Size(8, 8);

                rsStoreLocatorService.getStores()
                    .then((response) => {
                        const markers = [];

                        $scope.stores = response.data.map((store) => {
                            const coordinates = store.coordinates.split(', ');

                            store.lat = coordinates[0];
                            store.lng = coordinates[1];

                            return store;
                        });

                        $scope.stores.forEach((store) => {
                            // WCAG 4.1.2 (#943): title renders as aria-label + title on the
                            // gmp-advanced-marker element, naming each role="button" pin.
                            const marker = new google.maps.marker.AdvancedMarkerElement({
                                position: new google.maps.LatLng(store.lat, store.lng),
                                map: $scope.map,
                                title: store.name,
                            });

                            const content = '<div class="map-info">'
                                + '<h3>' + store.name + '</h3>'
                                + '<p>Address: ' + store.fullAddress + '</p>'
                                + '<span>Phone: ' + store.phone + '</span></div>';

                            const compiledContent = $compile(content)($scope);

                            google.maps.event.addListener(marker, 'click', (function ($marker, $content, scope) {
                                return function () {
                                    scope.infowindow.setContent($content);
                                    scope.infowindow.open(scope.map, $marker);
                                };
                            }(marker, compiledContent[0], $scope)));

                            markers.push(marker);
                        });

                        // eslint-disable-next-line no-unused-vars
                        const MarkersCluster = new markerClusterer.MarkerClusterer({
                            map: $scope.map,
                            markers,
                        });
                    });
            }

            $scope.infowindow = new google.maps.InfoWindow({
                content: '',
            });

            $scope.searchPlaceChanged = function () {
                const place = $scope.autocomplete.getPlace();

                if (!place || !place.geometry) {
                    $scope.errorMessage = 'There are not stores in this area';
                    return;
                }

                $scope.errorMessage = '';

                if ($scope.currentPositionMarker) {
                    $scope.currentPositionMarker.position = place.geometry.location;
                } else {
                    $scope.errorMessage = 'Enable geolocation in your browser';
                    return;
                }

                if ($scope.circle) {
                    $scope.circle.setMap(null);
                }

                if ($scope.radius !== '0') {
                    $scope.circle = new google.maps.Circle({
                        strokeColor: '#007bff',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: '#7eacdf',
                        fillOpacity: 0.35,
                        map: $scope.map,
                        center: place.geometry.location,
                        radius: Number($scope.radius) * 1609.34,
                    });

                    $scope.map.panToBounds($scope.circle.getBounds());
                    $scope.map.fitBounds($scope.circle.getBounds());

                    $scope.foundStoresCount = 0;
                    $scope.stores.forEach((store) => {
                        const distance = google.maps.geometry.spherical.computeDistanceBetween(
                            new google.maps.LatLng(store.lat, store.lng),
                            place.geometry.location,
                        );

                        if (distance <= $scope.circle.getRadius()) {
                            $scope.foundStoresCount += 1;
                        }
                    });
                } else {
                    $scope.foundStoresCount = 0;
                    $scope.map.setCenter(place.geometry.location);
                    $scope.map.setZoom(17); // Why 17? Because it looks good.
                }
            };

            function getCurrentPosition() {
                const pin = new google.maps.marker.PinElement({
                    glyphColor: 'black',
                    background: 'green',
                    borderColor: 'black',
                });

                if (navigator.geolocation && location.protocol === 'https:') {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        const coords = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

                        $scope.map.setCenter(coords);
                        $scope.map.setZoom(7);

                        $scope.currentPositionMarker = new google.maps.marker.AdvancedMarkerElement({
                            position: coords,
                            map: $scope.map,
                            content: pin.element,
                        });
                    });
                } else {
                    $scope.currentPositionMarker = new google.maps.marker.AdvancedMarkerElement({
                        position: $scope.map.getCenter(),
                        map: $scope.map,
                        content: pin.element,
                    });
                }
            }

            $scope.completePostalCode = function (code) {
                const output = [];

                if (code !== '') {
                    $scope.stores.forEach((store) => {
                        if (store.postalCode.toString().indexOf(code) >= 0) {
                            output.push(store);
                        }
                    });
                }

                $scope.filteredStores = output;
            };

            $scope.fillPostalCode = function (code) {
                $scope.postalCode = code;
                $scope.filteredStores = null;
            };

            google.maps.event.addDomListener(window, 'load', initialize);
        }]);
